enum AppRoutes  {
    homePage = "/",
    all = "*",    
} 


export default AppRoutes;